import * as Yup from "yup";
import formModel from './formModel';

const {
    formField: {
        password
    },
} = formModel;


export default [
    Yup.object().shape({
        [password.name]: Yup.string().required(`${password.requiredErrorMsg}`)
    }),
];